import "../Style/Header.css"
import HeaderCell from "./HeaderCell";
import ToggleArrow from "./ToggleArrow";

function Header(props) {

    return (
        <div className="header">
            <ToggleArrow isNeed={false} />
            <HeaderCell data="Train ID" isSortable={true} />
            <HeaderCell data="TD" isSortable={true} />
            <HeaderCell data="Type" />
            <HeaderCell data="Current Station" />
            <HeaderCell data="Next Station" />
            <HeaderCell data="Destination" />
            <HeaderCell data="Car 1" />
            <HeaderCell data="Car 2" />
            <HeaderCell data="Car 3" />
            <HeaderCell data="Car 4" />
            <HeaderCell data="Car 5" />
            <HeaderCell data="Car 6" />
            <HeaderCell data="Car 7" />
            <HeaderCell data="Car 8" />
            <HeaderCell data="Last Update" isSortable={true} />
        </div>
    );
}

export default Header;